var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.875 8.76208V13.638C2.875 14.0349 3.19688 14.3567 3.59375 14.3567H5.90625C6.30312 14.3567 6.625 14.0349 6.625 13.638V10.6767C6.625 10.293 6.93625 9.98173 7.32 9.98173H9.055C9.43875 9.98173 9.75 10.293 9.75 10.6767V13.638C9.75 14.0349 10.0719 14.3567 10.4688 14.3567H12.7812C13.1781 14.3567 13.5 14.0349 13.5 13.638V9.07458",
    stroke: "#555555",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.79422L7.51625 1.27797C7.88688 0.907344 8.48812 0.907344 8.85875 1.27797L15.375 7.79422",
    stroke: "#555555",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHut);
export default __webpack_public_path__ + "static/media/hut.599bb08f5929abbb9920cf0a56516813.svg";
export { ForwardRef as ReactComponent };